import BaseModel from './BaseModel';

/** Class representing an user. */
class TktUser extends BaseModel {
    constructor(properties) {
        super(properties);

        // ensure `contact.opaque` exists and is an object
        this.contact = this.contact || {};
        this.contact.opaque = this.contact.opaque || {};
        if (Array.isArray(this.contact.opaque))
            this.contact.opaque = Object.assign({}, this.contact.opaque);
    }

    isCustomer = () => {
        return this.roles.includes("customer");
    }

    isPihyve = () => {
        return this.roles.includes("pihyve");
    }
}

export default TktUser;
